"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The TokenizedCardDetails model module.
 * @module model/TokenizedCardDetails
 * @version 3.0
 */
var TokenizedCardDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>TokenizedCardDetails</code>.
   * @alias module:model/TokenizedCardDetails
   */
  function TokenizedCardDetails() {
    _classCallCheck(this, TokenizedCardDetails);
    TokenizedCardDetails.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(TokenizedCardDetails, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>TokenizedCardDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TokenizedCardDetails} obj Optional instance to populate.
     * @return {module:model/TokenizedCardDetails} The populated <code>TokenizedCardDetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new TokenizedCardDetails();
        if (data.hasOwnProperty('cardToken')) {
          obj['cardToken'] = _ApiClient["default"].convertToType(data['cardToken'], 'String');
        }
        if (data.hasOwnProperty('cardType')) {
          obj['cardType'] = _ApiClient["default"].convertToType(data['cardType'], 'String');
        }
        if (data.hasOwnProperty('expMonth')) {
          obj['expMonth'] = _ApiClient["default"].convertToType(data['expMonth'], 'String');
        }
        if (data.hasOwnProperty('expYear')) {
          obj['expYear'] = _ApiClient["default"].convertToType(data['expYear'], 'String');
        }
        if (data.hasOwnProperty('last4Digits')) {
          obj['last4Digits'] = _ApiClient["default"].convertToType(data['last4Digits'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TokenizedCardDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TokenizedCardDetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['cardToken'] && !(typeof data['cardToken'] === 'string' || data['cardToken'] instanceof String)) {
        throw new Error("Expected the field `cardToken` to be a primitive type in the JSON string but got " + data['cardToken']);
      }
      // ensure the json data is a string
      if (data['cardType'] && !(typeof data['cardType'] === 'string' || data['cardType'] instanceof String)) {
        throw new Error("Expected the field `cardType` to be a primitive type in the JSON string but got " + data['cardType']);
      }
      // ensure the json data is a string
      if (data['expMonth'] && !(typeof data['expMonth'] === 'string' || data['expMonth'] instanceof String)) {
        throw new Error("Expected the field `expMonth` to be a primitive type in the JSON string but got " + data['expMonth']);
      }
      // ensure the json data is a string
      if (data['expYear'] && !(typeof data['expYear'] === 'string' || data['expYear'] instanceof String)) {
        throw new Error("Expected the field `expYear` to be a primitive type in the JSON string but got " + data['expYear']);
      }
      // ensure the json data is a string
      if (data['last4Digits'] && !(typeof data['last4Digits'] === 'string' || data['last4Digits'] instanceof String)) {
        throw new Error("Expected the field `last4Digits` to be a primitive type in the JSON string but got " + data['last4Digits']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} cardToken
 */
TokenizedCardDetails.prototype['cardToken'] = undefined;

/**
 * @member {String} cardType
 */
TokenizedCardDetails.prototype['cardType'] = undefined;

/**
 * @member {String} expMonth
 */
TokenizedCardDetails.prototype['expMonth'] = undefined;

/**
 * @member {String} expYear
 */
TokenizedCardDetails.prototype['expYear'] = undefined;

/**
 * @member {String} last4Digits
 */
TokenizedCardDetails.prototype['last4Digits'] = undefined;
var _default = exports["default"] = TokenizedCardDetails;